import React from 'react'
import { ButtonSendStyle } from './style'

type ButtonSendProps = React.FC<{
  onClick?: () => void
  nameButton: string
  disabled?: boolean
}>

export const ButtonSend: ButtonSendProps = ({ onClick, nameButton, disabled }) => {
  return (
    <ButtonSendStyle>
      <button disabled={disabled} onClick={onClick}>
        {nameButton}
      </button>
    </ButtonSendStyle>
  )
}
